<a
  [routerLink]="routerLinkName"
  [routerLinkActive]="routerLinkActiveName"
  class="text-decoration-none fw-normal {{ currentRoute === '/template' && routerLinkName === 'templates' ? 'active '+extraClasses :  extraClasses }}"
  (click)="handleClick()"
>
  {{ linkText }} 
</a>
